import { render, staticRenderFns } from "./userSearch.vue?vue&type=template&id=b252c8ec&scoped=true"
import script from "./userSearch.vue?vue&type=script&lang=js"
export * from "./userSearch.vue?vue&type=script&lang=js"
import style0 from "./userSearch.vue?vue&type=style&index=0&id=b252c8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b252c8ec",
  null
  
)

export default component.exports